export function getGaClientId() {
  if (document.cookie) {
    // grouped pattern: /_ga=GA\d+\.\d+\.(?<clientId>\d+\.\d+)/
    const match = document.cookie.match(/_ga=(.+?);/);

    if (match) {
      return match[1].split('.').slice(-2).join('.');
    }

    return '';
  }
}

export function getGaSessionId() {
  if (document.cookie) {
    // grouped pattern: /_ga_\w+=GS\d+\.\d+\.(?<sessionId>\d+)\.(?<sessionNumber>\d+)\./
    const pattern = /_ga_\w+=GS\d\.\d\.(.+?)(?:;|$)/;
    const match = document.cookie.match(pattern);

    if (match) {
      const parts = match[1].split('.');
      return parts[0];
    }

    return '';
  }
}



// WEBPACK FOOTER //
// ./utils/extractGaClientId.js